import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import {GetAllLanguage, GetOneLanguage, DeleteLang} from '../../actions/index';

class LanguageAll extends Component {
    static contextTypes = {
        router: PropTypes.object
    };
    constructor(props){
        super(props);
        this.renderTable = this.renderTable.bind(this);
        this.editLang = this.editLang.bind(this);
        this.delLangOpenModal = this.delLangOpenModal.bind(this);
        this.delLang = this.delLang.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.addLang = this.addLang.bind(this);
    }
    componentWillMount(){
        let token = localStorage.getItem('id_token_admin');
        this.props.GetAllLanguage(token);
    }
    editLang(id, item){
        this.context.router.push('/language/all/edit/'+id);
    }
    addLang(){
        this.context.router.push('/language/all/add/');
    }
    delLangOpenModal(id, item){
        let token = localStorage.getItem('id_token_admin');
        let that= this;
        $('#DelLang').modal('show');
        $('#DelLang').on('shown.bs.modal', function () {
            that.props.GetOneLanguage(id, token);
        });
    }
    delLang(){
        let token = localStorage.getItem('id_token_admin');
        this.props.DeleteLang(this.props.lang.lang_one.id, token).then((response)=>{
            if(response.payload.status == 204){
                this.closeModal();
                this.props.GetAllLanguage(token);
            }
        });
    }
    closeModal(){
        $('#DelLang').modal('hide');
        this.props.lang.lang_one = {};
    }
    renderTable(){
        return this.props.lang.all_lang.results.map((item, i)=>{
            return(
                <div key={item.id} className="white-block common-list clearfix">
                    <p>{i+1}</p>
                    <p><span className="link-span" onClick={this.editLang.bind(this, item.id)}>{item.name}</span></p>
                    <p><img className="flag" src={item.flag} alt=""/></p>
                    <p>{item.code}</p>
                    <p>
                        <button type="button" onClick={this.editLang.bind(this, item.id)}>
                            <span className="span glyphicon glyphicon-edit" aria-hidden="true" />
                        </button>
                        <button type="button" onClick={this.delLangOpenModal.bind(this, item.id)}>
                            <span className="span glyphicon glyphicon-trash" />
                        </button>
                    </p>
                </div>
            )
        })
    }
    render() {
        return (
            <div className="dashboard-wrapper">
                <div className="dashboard-title clearfix"><p className="pull-left">All Languages</p>
                    <button onClick={this.addLang} type="button" className="pull-right btn btn-primary">
                        <span className="glyphicon glyphicon-plus" aria-hidden="true" />
                        Add language
                    </button>
                </div>
                {this.props.lang.all_lang.results && this.props.lang.all_lang.results.length > 0 ?
                    <div>
                        <div className="col-md-12">
                            <div className="common-list clearfix">
                                <p>#</p>
                                <p>Language</p>
                                <p>Flag</p>
                                <p>Code</p>
                                <p>Option</p>
                            </div>
                        </div>
                        <div className="col-md-12">
                            { this.renderTable() }
                        </div>
                    </div>
                    :
                    <div className={this.props.lang.all_lang.results && this.props.lang.all_lang.results.length < 0 || $.isEmptyObject(this.props.lang.all_lang) ? "for_preloader" : 'for_preloader dn'}>
                        <div className="preloader-wrapper big active">
                            <div className="spinner-layer spinner-blue-only">
                                <div className="circle-clipper left">
                                    <div className="circle" />
                                </div>
                                <div className="gap-patch">
                                    <div className="circle" />
                                </div>
                                <div className="circle-clipper right">
                                    <div className="circle" />
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {this.props.lang.all_lang.results && this.props.lang.all_lang.results.length === 0 && <p className="noResults">No items result</p>}

                <div className="modal fade" id="DelLang" tabIndex="-1" role="dialog" aria-labelledby="DelLangLabel">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" className="close" onClick={this.closeModal} aria-label="Close"><span aria-hidden="true">&times;</span></button>
                            </div>
                            <div className="modal-body text-center">
                                <span className="glyphicon glyphicon-alert" aria-hidden="true" data-toggle="modal" data-target="#DelLang"></span>
                                <p>Do you really want to delete this language {this.props.lang.lang_one ? <span>{this.props.lang.lang_one.name}</span> : ""}?</p>
                            </div>
                            <div className="modal-footer text-center">
                                <button onClick={this.closeModal} type="button" className="btn btn-default">No</button>
                                <button onClick={this.delLang} type="button" className="btn btn-primary">Yes</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="clearfix"></div>
            </div>
        );
    }
}

function  mapStateToProps(state) {
    return{
        lang: state.lang
    }
}
export default connect(mapStateToProps, {GetAllLanguage, GetOneLanguage, DeleteLang})(LanguageAll);


// WEBPACK FOOTER //
// ./src/components/language/all.js